import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17864b24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "language-switcher"
}
const _hoisted_3 = { class: "language-switcher__label" }
const _hoisted_4 = { class: "language-switcher__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "language-switcher__checkbox" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" })
], -1))
const _hoisted_6 = { class: "language-switcher__label" }
const _hoisted_7 = { class: "language-switcher__text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "language-switcher__checkbox" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" })
], -1))
const _hoisted_9 = { class: "setting-card-btn" }
const _hoisted_10 = { class: "setting-card-btn" }
const _hoisted_11 = { class: "setting-card-btn" }
const _hoisted_12 = { class: "delete-account" }
const _hoisted_13 = { class: "setting-card-btn" }
const _hoisted_14 = { class: "setting-card-btn" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-card-btn" }, " App Permissions ", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "settings__terms",
  href: "https://casedrive.co/terms-and-conditions"
}, " Terms and Conditions ", -1))
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "d-settings-wrapper" }
const _hoisted_20 = { class: "d-settings-wrapper__left" }
const _hoisted_21 = { class: "d-aside" }
const _hoisted_22 = { class: "d-aside__main-menu" }
const _hoisted_23 = { class: "d-settings-wrapper__right" }
const _hoisted_24 = {
  key: 0,
  class: "language-switcher"
}
const _hoisted_25 = { class: "language-switcher__label" }
const _hoisted_26 = { class: "language-switcher__text" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "language-switcher__checkbox" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" })
], -1))
const _hoisted_28 = { class: "language-switcher__label" }
const _hoisted_29 = { class: "language-switcher__text" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "language-switcher__checkbox" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" })
], -1))
const _hoisted_31 = { class: "setting-card-btn" }
const _hoisted_32 = { class: "setting-card-btn" }
const _hoisted_33 = { class: "setting-card-btn" }
const _hoisted_34 = { class: "delete-account cursor" }
const _hoisted_35 = { class: "setting-card-btn" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "setting-card-btn" }, " App Permissions ", -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "settings__terms",
  href: "https://casedrive.co/terms-and-conditions"
}, " Terms and Conditions ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_user_info = _resolveComponent("user-info")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_logout_confirmation_popup = _resolveComponent("logout-confirmation-popup")!
  const _component_delete_account_confirmation_popup = _resolveComponent("delete-account-confirmation-popup")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header),
        _createVNode(_component_el_container, {
          direction: "vertical",
          class: "settings height-100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_user_info),
            (_ctx.showLanguageSwitcher)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("label", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$localize('settings.language.en')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentLanguage) = $event)),
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setLanguage && _ctx.setLanguage(...args))),
                      name: "language-switcher",
                      type: "radio",
                      value: "en",
                      class: "language-switcher__input"
                    }, null, 544), [
                      [_vModelRadio, _ctx.currentLanguage]
                    ]),
                    _hoisted_5
                  ]),
                  _createElementVNode("label", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$localize('settings.key')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentLanguage) = $event)),
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setLanguage && _ctx.setLanguage(...args))),
                      name: "language-switcher",
                      type: "radio",
                      value: "key",
                      class: "language-switcher__input"
                    }, null, 544), [
                      [_vModelRadio, _ctx.currentLanguage]
                    ]),
                    _hoisted_8
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: "/settings/change-password",
              class: "setting-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localize('settings.change.password.button')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/settings/notifications",
              class: "setting-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$localize('settings.notifications.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/settings/sharing-settings",
              class: "setting-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$localize('settings.settings.title')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteConfirmPopup && _ctx.deleteConfirmPopup(...args)), ["prevent"])),
              class: "setting-card"
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$localize('settings.delete.account.title')), 1)
            ]),
            _createVNode(_component_router_link, {
              to: "/settings/help",
              class: "setting-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$localize('settings.help.title')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/",
              class: "setting-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "setting-card-btn",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showClueTooltip && _ctx.showClueTooltip(...args)))
                }, _toDisplayString(_ctx.$localize('settings.tutorial')), 1)
              ]),
              _: 1
            }),
            (_ctx.emailNotConfirmed)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendEmailConfirmation && _ctx.resendEmailConfirmation(...args)), ["prevent"])),
                  class: "setting-card"
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localize('settings.resend.email')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.mainStore.isFlutter)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openSystemSettings && _ctx.openSystemSettings(...args)), ["prevent"])),
                  class: "setting-card"
                }, _hoisted_16))
              : _createCommentVNode("", true),
            _hoisted_17,
            _createVNode(_component_app_button, {
              onClick: _withModifiers(_ctx.openConfirmPopup, ["prevent"]),
              type: "primary",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('app.settings.button')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.confirmDialog)
              ? (_openBlock(), _createBlock(_component_logout_confirmation_popup, {
                  key: 3,
                  onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmDialog = false)),
                  onConfirm: _ctx.logout,
                  class: "align-popup"
                }, null, 8, ["onConfirm"]))
              : _createCommentVNode("", true),
            (_ctx.confirmDelete)
              ? (_openBlock(), _createBlock(_component_delete_account_confirmation_popup, {
                  key: 4,
                  onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmDelete = false)),
                  onConfirm: _ctx.deleteAccount,
                  class: "align-popup"
                }, null, 8, ["onConfirm"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createVNode(_component_desktop_header, { class: "d-header" }),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("aside", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_drive_aside_main_menu)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_el_container, {
              direction: "vertical",
              class: "d-settings height-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_user_info),
                (_ctx.showLanguageSwitcher)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$localize('settings.language.en')), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentLanguage) = $event)),
                          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.setLanguage && _ctx.setLanguage(...args))),
                          name: "language-switcher",
                          type: "radio",
                          value: "en",
                          class: "language-switcher__input"
                        }, null, 544), [
                          [_vModelRadio, _ctx.currentLanguage]
                        ]),
                        _hoisted_27
                      ]),
                      _createElementVNode("label", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$localize('settings.key')), 1),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentLanguage) = $event)),
                          onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.setLanguage && _ctx.setLanguage(...args))),
                          name: "language-switcher",
                          type: "radio",
                          value: "key",
                          class: "language-switcher__input"
                        }, null, 544), [
                          [_vModelRadio, _ctx.currentLanguage]
                        ]),
                        _hoisted_30
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: "/settings/change-password",
                  class: "setting-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$localize('settings.change.password.button')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/settings/notifications",
                  class: "setting-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$localize('settings.notifications.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/settings/sharing-settings",
                  class: "setting-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$localize('settings.settings.title')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("a", {
                  onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteConfirmPopup && _ctx.deleteConfirmPopup(...args)), ["prevent"])),
                  class: "setting-card"
                }, [
                  _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$localize('settings.delete.account.title')), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/settings/help",
                  class: "setting-card"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$localize('settings.help.title')), 1)
                  ]),
                  _: 1
                }),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openSystemSettings && _ctx.openSystemSettings(...args)), ["prevent"])),
                      class: "setting-card"
                    }, _hoisted_37))
                  : _createCommentVNode("", true),
                _hoisted_38,
                _createVNode(_component_app_button, {
                  onClick: _withModifiers(_ctx.openConfirmPopup, ["prevent"]),
                  type: "primary",
                  class: "w-100 el-button-lg",
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('app.settings.button')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.confirmDialog)
                  ? (_openBlock(), _createBlock(_component_logout_confirmation_popup, {
                      key: 2,
                      onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.confirmDialog = false)),
                      onConfirm: _ctx.logout,
                      class: "align-popup"
                    }, null, 8, ["onConfirm"]))
                  : _createCommentVNode("", true),
                (_ctx.confirmDelete)
                  ? (_openBlock(), _createBlock(_component_delete_account_confirmation_popup, {
                      key: 3,
                      onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.confirmDelete = false)),
                      onConfirm: _ctx.deleteAccount,
                      class: "align-popup"
                    }, null, 8, ["onConfirm"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]))
}